export const getAuthors = () => `/api/v1/authors`;
export const findAuthor = authorSlug => `/api/v1/authors/${authorSlug}?include=articles,books,credentials`;
